import { IntegrationApiFeaturesCongestionReportsContractsDataUnderlyingAsset as UnderlyingAssets } from '@alliander-fe/api';
import { Box, Table } from '@ads-core/components';
import { quarterDateFormatter } from 'src/utils/dateFormatter';
import { bandWidthDateFormatter } from 'src/utils/bandwidth/bandWidthDateFormatter';
import { FALLBACK_VALUE } from './constant/constants';

type TableData = {
  underlyingAssets?: UnderlyingAssets[];
  mainAsset?: UnderlyingAssets | undefined;
};

export const CongestionTable = ({ mainAsset, ...props }: TableData) => {
  const underlyingAssets = props.underlyingAssets ? props.underlyingAssets : [];
  const assetData = mainAsset ? [mainAsset, ...underlyingAssets] : underlyingAssets;

  if (!assetData?.length) return null;

  const tableData = assetData.map((asset) => ({
    fields: {
      assetName: asset.name,
      cause: asset.cause,
      expectedEndDate: bandWidthDateFormatter({
        bandWidthStartDate: asset.expectedEndDateStart,
        bandWidthEndDate: asset.expectedEndDate,
        callbackFunction: (date) => quarterDateFormatter(date, FALLBACK_VALUE),
      }),
    },
    verticalAlign: 'top' as const,
  }));

  return (
    <Box
      padding={10}
      paddingBottom={{ initial: 10, md: 3 }}
      borderTopRightRadius="xl"
      bg="containerLight"
    >
      <Table
        data={tableData}
        columns={[
          {
            dataKey: 'assetName',
            title: 'Naam',
            style: { width: '30%' },
          },
          { dataKey: 'cause', title: 'Oorzaak' },
          { dataKey: 'expectedEndDate', title: 'Verwacht einde', style: { width: '30%' } },
        ]}
        title="Stations"
      />
    </Box>
  );
};
